<template lang="pug">
  .Pagination
    .Pagination-prev
      button.Btn.BtnIcon.Btn--blueColor(
        :disabled='!isPrevEnabled',
        @click="emitValue('page', currentPage - 1)")
        i.Icon.IconChevronLeft
    .Pagination-list
      template(v-for="page in pages")
        .Pagination-item(v-if="page !== null")
          button.Btn.Btn--outline(
            :class='{"Btn--blueBorder": currentPage !== page, "Btn--blue": currentPage === page, "Btn--blueColor": currentPage !== page}',
            @click="emitValue('page', page)") {{page + 1}}
        .Pagination-delimiter(v-else) ...
    .Pagination-next
      button.Btn.BtnIcon.Btn--blueColor(
        :disabled='!isNextEnabled',
        :class='{"Btn--blueBorder": true}',
        @click="emitValue('page', currentPage + 1)")
        i.Icon.IconChevronRight
</template>

<script>
  export default {
    name: "pagination",
    props: {
      count: Number,
      offset: Number,
      limit: Number,
    },
    computed: {
      pageCount() {
        return Math.ceil(this.count / this.limit)
      },
      pages() {
        let pages = [this.currentPage]
        if(this.currentPage > 0) {
          pages.unshift(this.currentPage - 1)
        }
        if(this.currentPage < this.pageCount - 1) {
          pages.push(this.currentPage + 1)
        }
        if(pages[0] > 1) {
          pages = [0, null].concat(pages)
        } else if(pages[0] > 0) {
          pages.unshift(0)
        }

        if(pages[pages.length - 1] < this.pageCount - 2) {
          pages = pages.concat([null, this.pageCount - 1])
        } else if(pages[pages.length - 1] < this.pageCount - 1){
          pages.push(this.pageCount - 1)
        }

        return pages
      },
      isNextEnabled() {
        return this.currentPage + 1 < this.pageCount
      },
      isPrevEnabled() {
        return this.currentPage > 0
      },
      currentPage() {
        return Math.floor(this.offset / this.limit)
      }
    },
    methods: {
      emitValue(action, value = null) {
        this.$emit(action, value * this.limit)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~base";

  #app .Pagination {
    --paginationBtnBorder: #{$grey3};
    --paginationArrowsBtnBg: #{$grey13};
  }

  #app[data-theme='dark'] .Pagination {
    --paginationBtnBorder: #{$grey3};
    --paginationArrowsBtnBg: #{$grey13};
  }

  .Pagination {
    display: flex;
    align-items: center;
    font-size: 13px;

    .Btn {
      min-width: 48px;
      border: 1px solid var(--paginationBtnBorder);

      .Icon {
        font-size: 16px;
      }

      &:disabled {
        opacity: 0;
      }
    }

    &-prev,
    &-next {
      flex: 0 0 48px;

      .Btn {
        background: var(--paginationArrowsBtnBg);
      }
    }

    &-delimiter {
      color: var(--accentColor);
    }

    &-list {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
    }

    &-item,
    &-delimiter {
      margin: 0 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue